import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NotificationType } from 'angular2-notifications';
import { NotificationToast } from '../../model/notification-toast';

@Component({
  selector: 'app-snack-bar',
  templateUrl: './notifications-toast.component.html',
  styleUrls: ['./notifications-toast.component.scss'],
})
export class NotificationsToastComponent implements OnInit {
  @Input() notification: NotificationToast = new NotificationToast();
  @ViewChild('customSnackBar', { static: true }) customSnackBar: TemplateRef<any>;
  
  constructor() {}

  ngOnInit(): void {}
}
